/* E-Mail-Adressen: Klick kopiert, statt ungefragt das Mailprogramm zu oeffnen.
 *
 * Ein mailto reisst bei vielen Besuchern ein fremdes Programm auf (oder gar nichts,
 * wenn keins eingerichtet ist) — beides ist ein Abbruch im Kaufweg. Der Klick legt
 * die Adresse jetzt in die Zwischenablage und blendet daneben einen zweiten Weg ein,
 * der das Mailprogramm doch oeffnet. Die Adresse bleibt sichtbar und im href stehen,
 * die Pflichtangabe im Impressum ist damit unveraendert erfuellt.
 */
(function () {
  'use strict';

  function meldung(el, text) {
    var alt = el.querySelector('.ta-mail-hinweis');
    if (alt) alt.remove();
    var s = document.createElement('span');
    s.className = 'ta-mail-hinweis';
    s.textContent = text;
    el.appendChild(s);
    setTimeout(function () { s.classList.add('ta-mail-hinweis--weg'); }, 2600);
    setTimeout(function () { s.remove(); }, 3100);
  }

  function kopieren(adresse) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(adresse);
    }
    return new Promise(function (erfuellt, verworfen) {
      var h = document.createElement('textarea');
      h.value = adresse;
      h.setAttribute('readonly', '');
      h.style.cssText = 'position:absolute;left:-9999px';
      document.body.appendChild(h);
      h.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      h.remove();
      ok ? erfuellt() : verworfen();
    });
  }

  function verdrahten() {
    document.querySelectorAll('a[href^="mailto:"]').forEach(function (a) {
      if (a.dataset.taMail) return;
      a.dataset.taMail = '1';
      a.addEventListener('click', function (ev) {
        // Zweitklick auf den eingeblendeten Weg soll wirklich oeffnen
        if (a.dataset.taOeffnen === '1') { a.dataset.taOeffnen = ''; return; }
        ev.preventDefault();
        var adresse = a.getAttribute('href').replace(/^mailto:/, '').split('?')[0];
        var huelle = a.parentNode;
        kopieren(adresse).then(function () {
          meldung(huelle, 'Adresse kopiert');
        }).catch(function () {
          a.dataset.taOeffnen = '1';
          a.click();
        });
        var oeffnen = huelle.querySelector('.ta-mail-oeffnen');
        if (!oeffnen) {
          oeffnen = document.createElement('a');
          oeffnen.className = 'ta-mail-oeffnen';
          oeffnen.href = a.getAttribute('href');
          oeffnen.textContent = 'im Mailprogramm öffnen';
          oeffnen.addEventListener('click', function (e) { e.stopPropagation(); });
          huelle.appendChild(oeffnen);
          setTimeout(function () { if (oeffnen) oeffnen.remove(); }, 9000);
        }
      });
    });
  }

  verdrahten();
  new MutationObserver(verdrahten).observe(document.documentElement, { childList: true, subtree: true });
})();
